import type { FC } from "react";
import Select from "react-select";

import type { IOption } from "store/slices/topicPractice";

import { useFixedMenu } from "../useFixedMenu";

interface Props {
  index: number;
  placeholder: string;
  options: IOption[];
  selected?: string;
  onChange: (index: number, value: string) => void;
}

const Option: FC<Props> = ({ index, placeholder, options, selected, onChange }) => {
  const fixedMenu = useFixedMenu();

  // `auto` přehodí nabídku nahoru a omezí ji; bez omezení zůstane jen když je na obou stranách méně než
  // `MIN_MENU_HEIGHT` (viewport pod ~320 px), to necháváme být.
  return (
    <Select
      {...fixedMenu}
      name="subject"
      className={"react-select-container"}
      classNamePrefix="react-select"
      placeholder={placeholder}
      isSearchable={false}
      menuPlacement="auto"
      options={options.map(option => ({
        value: option.value ?? "",
        label: option.value ?? "",
      }))}
      onChange={e => {
        onChange(index, e?.value ?? "");
      }}
      value={selected ? { value: selected, label: selected } : null}
    />
  );
};

export default Option;
